(() => {
  const root = document.documentElement;
  if (!root.hasAttribute('data-orion-page-loading')) return;
  let observer, closed = false, fontsReady = !document.fonts;
  const controller = new AbortController();
  const finish = () => {
    if (closed) return;
    closed = true;
    observer?.disconnect();
    controller.abort();
    if (!root.hasAttribute('data-orion-page-loading')) return;
    root.dataset.orionPageLoading = 'revealing';
    const done = () => {
      root.removeAttribute('data-orion-page-loading');
      document.dispatchEvent(new Event('orion:page-ready'));
    };
    // The owner's rule: this motion plays also when the system asks for reduced motion.
    setTimeout(done, 240);
  };
  const inspect = () => {
    const gallery = document.querySelector('orion-mattress-gallery[data-performance-pilot]');
    if (fontsReady && gallery && /^(ready|empty|error)$/.test(gallery.dataset.state)) finish();
  };
  const start = () => {
    if (closed || !root.hasAttribute('data-orion-page-loading')) return;
    const gallery = document.querySelector('orion-mattress-gallery[data-performance-pilot]');
    if (gallery) {
      observer = new MutationObserver(inspect);
      observer.observe(gallery, { attributes:true, attributeFilter:['data-state'] });
    } else { finish(); return; }
    const overlay = document.getElementById('OrionPageSkeleton');
    // Interaction always releases the loading shell; it never blocks a visitor.
    overlay?.addEventListener('pointerdown', finish, { once:true, signal:controller.signal });
    window.addEventListener('wheel', finish, { once:true, passive:true, signal:controller.signal });
    document.addEventListener('keydown', finish, { once:true, signal:controller.signal });
    document.addEventListener('orion:page-ready', () => { observer?.disconnect(); controller.abort(); }, { once:true, signal:controller.signal });
    inspect();
  };
  if (document.fonts) Promise.resolve(document.fonts.ready).then(() => { fontsReady = true; inspect(); }).catch(() => { fontsReady = true; inspect(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true, signal:controller.signal });
  else start();
  window.addEventListener('pageshow', event => { if (event.persisted) finish(); }, { signal:controller.signal });
})();
